import React from "react";
import Bookings from "../Bookings";
import { indiaOperations } from "../../utils/indiaOperationsSource";

/** India "Bookings" page: the Australian Bookings page on India data (₹). */
const IndiaBookings = () => <Bookings source={indiaOperations} />;

export default IndiaBookings;
